import { createFileRoute } from "@tanstack/react-router";

import { ConsoleMachines } from "../features/console/account";

export const Route = createFileRoute("/console/machines/")({
  component: ConsoleMachines,
});
